module.exports = __webpack_public_path__ + "img/building.2f03b3a4.png";